import Link from "next/link";

import Button from "@components/Button";

import SourcePlaceholder from "assets/svgs/source.svg";

export default function SourceFeatured({ className, featuredSource, slug }) {
  const { classification, icon_url, title, url } = featuredSource;

  const iconOrPlaceholderUrl = (icon_url && icon_url.indexOf("airtable") === -1) ? icon_url : null;

  return (
    <section className="max-w-6xl	mx-auto pt-14 px-4 xl:px-0">
      <h2 className="highlight">Featured Sources</h2>
      <article
        className={`bg-white border flex flex-col	justify-between mt-4 px-6 pt-6 rounded-md ${className}`}
      >
        {url && (
          <Link href={url}>
            <a className="block" target="_blank" rel="noopener noreferrer">
              <figure className="flex items-center">
                <div className="flex-shrink-0	h-28 mr-4 text-gray-400 w-28">
                  {iconOrPlaceholderUrl ? (
                    <img src={iconOrPlaceholderUrl} height="112" width="112" />
                  ) : (
                    <SourcePlaceholder className="mx-auto" width="112" />
                  )}
                </div>
                <figcaption className="flex flex-col text-sm">
                  {title && <span className="font-semibold">{title}</span>}
                  {classification && (
                    <Button className="mt-3" emphasis="secondary" height="28">
                      {classification === "Podcast" ? "Listen" : "View"} Now
                    </Button>
                  )}
                </figcaption>
              </figure>
            </a>
          </Link>
        )}
        <Link href={`/cases/${slug}/sources`}>
          <a className="block border-t flex-shrink-0 font-semibold py-3 text-center text-red text-sm hover:text-red-700">
            See All Sources
          </a>
        </Link>
      </article>
    </section>
  );
}
